import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import ActionButtonTerminate from '../../../../../../components/ActionButtonTerminate';
import ActionButtonSqOff from '../../../../../../components/ActionButtonSqOff';
import TooltipEnclosure from '../../../../../../components/TooltipEnclosure';
import { getAlgoListDataCachedSelectedDay } from '../../../../../../stores/algos-list/getters';
import { terminateAlgoStart } from '../../../../../../stores/algos-list/actions';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    '& .button-holder': {
      marginRight: 11,
    },

    '& .progress': {
      marginRight: 16,
      display: 'flex',
      alignItems: 'center',
      '& .MuiCircularProgress-indeterminate': {
        animationDuration: '0.65s',
      },
    },
  },
}));

const ActionButtons = ({ original }) => {
  const dispatch = useDispatch();
  const { _id = '' } = original;
  const sqOffLoading = useSelector((state) => {
    const { sqOffLoading = false } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return sqOffLoading;
  });

  const handleOpenTerminateModal = (data) => {
    dispatch(terminateAlgoStart(data));
  };

  return (
    <>
      {sqOffLoading ? (
        <div className="progress">
          <CircularProgress disableShrink size={22} thickness={5} />
        </div>
      ) : (
        <>
          <TooltipEnclosure
            title="Square off all positions & Terminate algo"
            className="button-holder"
          >
            <ActionButtonSqOff
              onClick={() =>
                handleOpenTerminateModal({
                  action: 'SQ_OFF_TERMINATE',
                  algoId: _id,
                })
              }
            />
          </TooltipEnclosure>

          <TooltipEnclosure title="Terminate algo" className="button-holder">
            <ActionButtonTerminate
              onClick={() =>
                handleOpenTerminateModal({
                  action: 'TERMINATE',
                  algoId: _id,
                })
              }
            />
          </TooltipEnclosure>
        </>
      )}
    </>
  );
};

const ActionSection = ({ original = {} }) => {
  const classes = useStyles();
  const { _id = '' } = original;

  const status = useSelector((state) => {
    const { status = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return status;
  });

  return (
    <div className={classes.root}>
      {status === 'TRADE_ACTIVE' ? <ActionButtons original={original} /> : ''}
    </div>
  );
};

export default ActionSection;
